module.exports = __webpack_public_path__ + "static/logixx-logo-271a69c7d5fabf83d17a72adabcbcafb.jpg";